import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { captureUTM } from "./analytics/events";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Homepage from "./components/Homepage";
import Scroll from "./components/Scroll";
import Footer from "./Footer/Footer";
import Navbar from "./components/Navbar";
import GymDetail from "./Gym-Detail/GymDetail";
import GymList from "./Gym-List/GymList";
import BlogList from "./Blog-Page/blogList";
import BlogDetail from "./Blog-Page/BlogDetail";
import HttpsRedirect from "react-https-redirect";
import Plan from "./Plan/Plan";
import Privacypolicy from "./components/Privacypolicy";
import Termsuse from "./components/Termsuse";
import ErrorPage from "./components/ErrorPage";
import GymListing from "./components/GymListing";
import Help from "./components/Help";
import GymSetup from "./components/GymSetup";
import Product from "./Product/Product";
import ProductList from "./Product/ProductList";
import ProductDetail from "./Product/ProductDetail";
import GymMembership from "./components/GymMembership";
import GymSoftware from "./components/GymSoftware";
import Trainer from "./Fitness-Trainer/Trainer";
import TrainerDetail from "./Fitness-Trainer/TrainerDetail";
import TrainerList from "./Fitness-Trainer/TrainerList";
import TrainerHomepage from "./components/TrainerHomepage";
import Login from "./auth/Login";
import TrainerPublicProfile from "./pages/TrainerPublicProfile";
import TrainerRegister from "./pages/TrainerRegister";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import ContactUsPage from "./pages/ContactUsPage";
import AboutUsPage from "./pages/AboutUsPage";
import ProtectedRoute from "./components/ProtectedRoute";

// Import all dashboard pages
import DashboardHome from "./pages/DashboardHome";
import BasicInfoPage from "./pages/BasicInfoPage";
import ProfessionalPage from "./pages/ProfessionalPage";
import ServicesPage from "./pages/ServicesPage";
import AvailabilityPage from "./pages/AvailabilityPage";
import MediaPage from "./pages/MediaPage";
import ClientsPage from "./pages/ClientsPage";
import ReviewsPage from "./pages/ReviewsPage";
import SettingsPage from "./pages/SettingsPage";
import ServiceDetail from "./pages/ServiceDetail";
import ConsultationEnquiriesPage from "./pages/ConsultationEnquiriesPage";

function HomeSeoKeywords() {
  const location = useLocation();
  if (location.pathname !== "/") return null;
  return (
    <div className="seo-keywords-section">
      <div className="container">
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">GYM BOOKING</h6>
          <p className="seo-kw-list">Gym Near Me, Best Gym in India, Online Gym Booking, Book Gym Membership Online, Find Gym Near Me, Gym Membership Plans, Monthly Gym Pass, Annual Gym Membership, Gym Free Trial, Gym Day Pass, Trusted Gym Platform, MeraGym Booking, Gym Discovery India, Join Gym Online, Compare Gym Prices</p>
        </div>
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">GYM TYPES</h6>
          <p className="seo-kw-list">Normal Gym, Unisex Gym, Ladies Gym, CrossFit Box, Yoga Studio, Zumba Center, Pilates Studio, Boxing Gym, MMA Gym, Functional Fitness Center, Bodybuilding Gym, Weight Training Gym, Cardio Gym, 24 Hour Gym, Open Gym, Home Gym Setup, Commercial Gym, Corporate Gym, Boutique Fitness Studio, Luxury Gym</p>
        </div>
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">GYM BY CITY</h6>
          <p className="seo-kw-list">Gym in Varanasi, Gym in Delhi, Gym in Mumbai, Gym in Bangalore, Gym in Hyderabad, Gym in Chennai, Gym in Pune, Gym in Kolkata, Gym in Jaipur, Gym in Lucknow, Gym in Noida, Gym in Gurgaon, Gym in Ahmedabad, Gym in Surat, Gym in Indore, Gym in Bhopal, Gym in Patna, Gym in Chandigarh, Gym in Agra, Gym in Kanpur</p>
        </div>
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">FITNESS GOALS</h6>
          <p className="seo-kw-list">Weight Loss Gym, Muscle Building Gym, Fat Burn Workout, Strength Training, Cardio Fitness, Body Transformation, HIIT Training Center, Functional Training, Abs Workout Gym, Endurance Training, Flexibility Training, Sports Fitness, Athletic Training, Gym for Seniors, Gym for Women, Gym for Beginners, Post Injury Rehabilitation Gym, Lean Muscle Building</p>
        </div>
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">GYM AMENITIES</h6>
          <p className="seo-kw-list">Gym with Swimming Pool, Gym with Sauna, Gym with Steam Room, Gym with Locker Room, Gym with Parking, AC Gym, Gym with Shower, Gym with Café, Gym with Childcare, Gym with Basketball Court, Gym with Sports Facilities, Gym with Group Classes, Gym with Diet Consultation, Gym with Physiotherapy, Gym with Body Composition Test</p>
        </div>
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">CLASSES &amp; TRAINING</h6>
          <p className="seo-kw-list">Personal Trainer Near Me, Yoga Classes Near Me, Zumba Classes Near Me, CrossFit Classes, Aerobics Classes, Kickboxing Classes, Spinning Classes, Dance Fitness Classes, Online Personal Training, Group Fitness Classes, Strength &amp; Conditioning Coach, Certified Fitness Trainer, Nutrition Coach Near Me, Online Fitness Coach, Diet &amp; Workout Plan</p>
        </div>
      </div>
    </div>
  );
}

function TrainerSeoKeywords() {
  const location = useLocation();
  if (location.pathname !== "/gym-fitness-trainer") return null;
  return (
    <div className="seo-keywords-section">
      <div className="container">
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">PERSONAL TRAINER</h6>
          <p className="seo-kw-list">Personal Trainer Near Me, Certified Personal Trainer, Best Personal Trainer in India, Fitness Trainer Near Me, Find Personal Trainer, Personal Trainer for Weight Loss, Personal Trainer for Muscle Building, Hire Personal Trainer, Personal Trainer at Home, Private Fitness Coach, Professional Fitness Trainer, Experienced Personal Trainer, Affordable Personal Trainer, Trusted Fitness Coach</p>
        </div>
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">TRAINER BY CITY</h6>
          <p className="seo-kw-list">Personal Trainer in Varanasi, Personal Trainer in Delhi, Personal Trainer in Mumbai, Personal Trainer in Bangalore, Personal Trainer in Hyderabad, Personal Trainer in Chennai, Personal Trainer in Pune, Personal Trainer in Kolkata, Personal Trainer in Jaipur, Personal Trainer in Lucknow, Personal Trainer in Noida, Personal Trainer in Gurgaon, Personal Trainer in Ahmedabad, Personal Trainer in Indore, Fitness Coach in India</p>
        </div>
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">TRAINING GOALS</h6>
          <p className="seo-kw-list">Weight Loss Personal Trainer, Muscle Building Coach, Fat Loss Trainer, Body Transformation Coach, Strength Training Coach, Cardio Fitness Trainer, HIIT Personal Trainer, Functional Training Coach, Sports Performance Trainer, Post Pregnancy Fitness Trainer, Trainer for Beginners, Senior Fitness Trainer, Trainer for Women, Athletic Performance Coach, Injury Rehabilitation Trainer</p>
        </div>
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">TRAINER SPECIALISATIONS</h6>
          <p className="seo-kw-list">Yoga Instructor Near Me, Zumba Instructor Near Me, CrossFit Coach Near Me, Pilates Instructor, Kickboxing Trainer, Boxing Coach, MMA Trainer, Dance Fitness Instructor, Aerobics Trainer, Spinning Coach, Nutrition &amp; Diet Coach, Bodybuilding Coach, Powerlifting Coach, Calisthenics Trainer, Flexibility &amp; Mobility Coach</p>
        </div>
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">ONLINE TRAINING</h6>
          <p className="seo-kw-list">Online Personal Trainer India, Virtual Fitness Coach, Online Workout Plan, Online Diet &amp; Fitness Coach, Remote Personal Training, Online Strength Coach, Home Workout Trainer, Online HIIT Coach, Digital Fitness Trainer, Video Personal Training Sessions, Online Yoga Coach, Custom Online Workout Program, Online Fitness Consultation, Online Body Transformation Program</p>
        </div>
        <div className="seo-kw-group">
          <h6 className="seo-kw-heading">CERTIFICATION &amp; EXPERTISE</h6>
          <p className="seo-kw-list">ACE Certified Trainer, NASM Certified Trainer, NSCA Certified Coach, CPR Certified Fitness Trainer, Government Certified Fitness Instructor, Sports Science Graduate, Diploma in Personal Training, Certified Nutrition Coach, Certified Yoga Instructor, Certified Zumba Instructor, Experienced Gym Trainer, ISSA Certified Trainer, Fitness Expert India, Verified Fitness Professional</p>
        </div>
      </div>
    </div>
  );
}

function UTMCapture() {
  const location = useLocation();
  useEffect(() => { captureUTM(); }, [location]);
  return null;
}

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <HttpsRedirect>
        <Navbar />
        <UTMCapture />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/create-fitness-trainer-profile" element={<TrainerRegister />} />
          <Route path="/trainer/:slug" element={<TrainerPublicProfile />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/plans" element={<Plan />} />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
          <Route path="/terms-of-use" element={<Termsuse />} />
          <Route path="/gym-membership-discounts-coupon" element={<GymMembership />} />
          <Route path="/free-gym-listing" element={<GymListing />} />
          <Route path="/gym-setup-and-design-work" element={<GymSetup />} />
          <Route path="/gym-management-software" element={<GymSoftware />} />
          <Route path="/shop" element={<Product />} />
          <Route path="/shop/:category" element={<ProductList />} />
          <Route path="/shop/:category/:slug" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/gym-fitness-trainer" element={<TrainerHomepage />} />
          <Route path="/gym-fitness-trainer/:city" element={<TrainerList />} />
          <Route path="/gym-fitness-trainer/:city/:slug" element={<TrainerDetail />} />
          <Route path="/service/:trainerSlug/:serviceId" element={<ServiceDetail />} />
          <Route path="/error" element={<ErrorPage />} />

          {/* Protected Dashboard Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/basic-info"
            element={
              <ProtectedRoute>
                <BasicInfoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/professional"
            element={
              <ProtectedRoute>
                <ProfessionalPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/services"
            element={
              <ProtectedRoute>
                <ServicesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/availability"
            element={
              <ProtectedRoute>
                <AvailabilityPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/media"
            element={
              <ProtectedRoute>
                <MediaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <ClientsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reviews"
            element={
              <ProtectedRoute>
                <ReviewsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/enquiries"
            element={
              <ProtectedRoute>
                <ConsultationEnquiriesPage />
              </ProtectedRoute>
            }
          />

          {/* Gym routes - must be after specific routes */}
          <Route path="/search/:query" element={<GymList />} />
          <Route path="/gyms" element={<GymList />} />
          <Route path="/gyms/:category" element={<GymList />} />
          <Route path="/:city/:category" element={<GymList />} />
          <Route path="/:slug" element={<GymDetail />} />

          {/* Catch-all route for homepage - must be last */}
          <Route path="*" element={<Homepage />} />
        </Routes>
        <Help />
        <HomeSeoKeywords />
        <TrainerSeoKeywords />
        <Footer />
        <Scroll />
      </HttpsRedirect>
    </>
  );
}

export default App;
